<template>
  <WrapperAutocomplete
    placeholder="Nom ou prénom"
    strict
    v-model="salarieSectionné"
    :search="search"
    :search-min-length="3"
    :get-input-text="getLabel"
    :get-item-label="getLabel"
    :label
    :required
    :help
    :hint
    :alert-label
    :alert-type
    :disabled
    :readonly
  >
    <template #default="item">
      <div class="flex-1 flex flex-column">
        <div class="flex-1">
          <BasicText weight="bold">
            <template v-if="item.sexe === 'Homme'">M.</template>
            <template v-if="item.sexe === 'Femme'">Mme.</template>
            {{ item.prenom }} {{ item.nom }}
          </BasicText>
        </div>
        <div
          class="flex-1"
          v-if="'nir' in item && item.nir && item.dateNaissance"
        >
          <BasicText
            size="body-m"
            color="primary-600"
            v-if="item.nir"
          >
            Nir : {{ item.nir }}
            <template v-if="item.nirTemporaire">(temporaire)</template>
          </BasicText>
          <BasicText
            size="body-m"
            color="primary-600"
            v-if="item.dateNaissance"
          >
            <template v-if="item.sexe === 'Femme'">Née le :</template>
            <template v-else>Né le :</template>
            {{ dateFormatter(item.dateNaissance) }}
          </BasicText>
        </div>
      </div>
    </template>
  </WrapperAutocomplete>
</template>

<script setup lang="ts" generic="Mode extends RechercheSalarieMode">
  import { computed, ref } from 'vue'
  import type { WrapperFormElementProps } from '@designSystem/components'
  import { dateFormatter } from '@/features/shared/tools/date'
  import { useRechercheSalarie } from './useRechercheSalarie'
  import type {
    RechercheSalarieMode,
    RechercheSalarieProps,
    SalarieInfoDto,
    RechercheSalarieEvents,
  } from './RechercheSalarie.type'
  import type { SalarieRechercheDTO, TuteurRechercheDTO } from '@/features/api/extranet/dto/Demande/shared'

  const props = withDefaults(defineProps<RechercheSalarieProps<Mode> & WrapperFormElementProps>(), {
    label: 'Rechercher un salarié',
    readonly: false,
    disabled: false,
  })
  const emit = defineEmits<RechercheSalarieEvents<Mode>>()

  const services = useRechercheSalarie({ idDemande: props.idDemande, mode: props.mode })

  type LocalTypeSalarie = (SalarieRechercheDTO | TuteurRechercheDTO) & { key: string }

  const getLabel = function (value: LocalTypeSalarie) {
    return `${value.prenom} ${value.nom}`
  }

  const search = (search: string) => services.searchSalaries(search) as Promise<LocalTypeSalarie[]>

  const salarieSectionnéInt = ref<LocalTypeSalarie>()
  const salarieSectionné = computed({
    get: () => salarieSectionnéInt.value,
    set: (value) => {
      if (value?.key) {
        const { key, ...result } = value
        emit('selected', result as SalarieInfoDto<Mode>)
        salarieSectionnéInt.value = undefined
      } else {
        salarieSectionnéInt.value = value
      }
    },
  })
</script>

